module.exports = __webpack_public_path__ + "fonts/ralewayextrabolditalic.521affa.ttf";